<template>
  <v-container>
      <v-dialog v-model="completeDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Request Successful</v-card-title>
          <v-card-text>Your request has been successfully sent to the server.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="refreshApp">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="errorDialog" persistent>
        <v-card>
          <v-card-title class="headline">Offline</v-card-title>
          <v-card-text>
            <v-alert v-model="errorDialog" icon="cloud_off" type="error">You are currently offline, Please try again later</v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="refreshApp">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="errorDateDialog" persistent>
        <v-card>
          <v-card-title class="headline">Shift Conflict</v-card-title>
          <v-card-text>
            <v-alert v-model="errorDateDialog" icon="mdi-clock-alert" type="error">You have already clocked in with this start time</v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat to="/">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-container>
        <v-form v-model="formValid" ref="form" lazy-validation>
          <v-select label="Clock In/Out" v-model="mode" :items="['In', 'Out']"></v-select>
          <v-dialog
            ref="dateDialog"
            persistent
            v-model="dateDialog"
            lazy
            full-width
            width="290px"
            :return-value.sync="date"
          >
            <v-text-field
              slot="activator"
              :label="mode === 'In' ? 'Start Date' : 'End Date'"
              v-model="formatDate"
              prepend-icon="event"
              readonly
              :rules="timeRules"
            ></v-text-field>
            <v-date-picker v-model="date" actions full-width>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="dateDialog = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dateDialog.save(date)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
          <v-dialog
            ref="timeDialog"
            persistent
            v-model="timeDialog"
            lazy
            full-width
            width="fit-content"
            :return-value.sync="time"
          >
            <v-text-field
              slot="activator"
              :label="mode === 'In' ? 'Start Time' : 'End Time'"
              v-model="timeFormat"
              prepend-icon="access_time"
              readonly
              :rules="timeRules"
            ></v-text-field>
            <b-timepicker
              inline
              size="is-large"
              placeholder="Click to select..."
              icon="clock"
              v-model="time"
              :time-parser="formatTimeStringToDate"
              :time-format="formatTimeDateToString"
              hour-format="12">
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="timeDialog = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.timeDialog.save(time)">OK</v-btn>
          </b-timepicker>
          </v-dialog>
          <v-select
            v-if="mode === 'In'"
            label="Load Numbers"
            v-model="load"
            prepend-icon="local_shipping"
            ref="loadSelect"
            chips
            tags
            clearable
            type="text"
            append-icon=""
            @keyup.native="getCharCode">
            <template slot="selection" slot-scope="data">
              <v-chip
                close
                @input="remove(data.item)"
                :selected="data.selected"
                color="primary white--text">
                {{ data.item }}&nbsp;
              </v-chip>
            </template></v-select>
          <v-text-field
            v-else
            label="Night Out Reference"
            v-model="nightOut"
            prepend-icon="hotel"
            type="number"
            :rules="nightOutRules"
            ></v-text-field>
          <v-btn class="primary" :loading="loading" block @click="submitClockIn" :disabled="!formValid">Confirm {{mode === 'In' ? 'Start' : 'End'}}</v-btn>
        </v-form>
      </v-container>
    <Disclaimer-Dialog :show-dialog.sync="displayDisclaimer" @declined="disclaimerAction"></Disclaimer-Dialog>
  </v-container>
</template>

<script>
import moment from 'moment'
import {firedb} from '../firebase'
import dbPromise from '../dbPromise'

export default {
  props: ['pin'],
  data () {
    return {
      mode: 'In',
      url: this.$store.getters.url,
      dateDialog: false,
      date: null,
      timeDialog: false,
      time: null,
      timeFormat: null,
      load: [],
      completeDialog: false,
      errorDialog: false,
      errorDateDialog: false,
      company: this.$store.getters.company,
      clockInFlagLimit: this.$store.getters.clockInFlagLimit,
      loading: false,
      gps: null,
      loadIdRules: [
        v => (v.length < 19) || 'Maximum length exceeded'
      ],
      nightOutRules: [
        v => (v.length < 19) || 'Maximum length exceeded'
      ],
      nightOut: '',
      formValid: true,
      displayDisclaimer: true,
      clockInLimit: this.$store.getters.clockInLimit
    }
  },
  created () {
    this.date = moment().format('YYYY-MM-DD')
    this.time = moment().toDate()
    if (this.$store.getters.disclaimerText === '' || this.$store.getters.disclaimerText === false || this.$store.getters.disclaimerText === undefined) {
      this.displayDisclaimer = false
    } else {
      this.displayDisclaimer = !this.$store.getters.disclaimerAccepted
    }
  },
  mounted () {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.gps = position.coords.latitude + ' ' + position.coords.longitude
      })
    }
    this.$store.dispatch('checkLoginTime')
  },
  watch: {
    time: function (value) {
      this.timeFormat = moment(new Date(value)).format('hh:mm a')
    }
  },
  computed: {
    formatDate () {
      return moment(this.date).format('DD/MM/YYYY')
    },
    timeRules () {
      let arr = []
      if (this.clockInLimit > -1) {
        arr.push(v => (moment(this.date + ' ' + this.timeFormat, 'YYYY-MM-DD HH:mm a').isSameOrAfter(moment().subtract(this.clockInLimit, 'minutes'), 'minute')) || 'Clocking out in the past is not allowed')
      }
      return arr
    }
  },
  methods: {
    refreshApp () {
      location.reload()
    },
    submitClockIn () {
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.mode === 'In') {
          const val = this.$refs.loadSelect.getCurrentTag()
          if (val !== '' && val !== undefined && val !== null) {
            this.triggerUpdateChip()
          }
        }
        let start = this.date + ' ' + moment(this.timeFormat, 'hh:mm a').format('HH:mm')
        if (this.company !== '') {
          let delayedStart = 0
          if (this.clockInFlagLimit && this.clockInFlagLimit > -1) {
            const diff = moment().diff(moment(start, 'YYYY-MM-DD HH:mm'), 'minutes')
            if (diff > this.clockInFlagLimit) {
              delayedStart = 1
            }
          }
          let postObj = {
            pin: this.pin,
            company: this.company,
            type: this.mode.toLowerCase(),
            data: {
              start: start,
              end: start,
              load_array: this.load,
              nightOut: this.nightOut,
              gps: this.gps
            },
            delayed_start: delayedStart
          }
          firedb.ref('recoveryData').push(postObj)
            .then(() => {
              this.loading = false
              this.completeDialog = true
            })
            .catch(() => {
              this.loading = false
              this.errorDateDialog = true
            })
        }
      }
    },
    addNewClockIn (start) {
      let timesheet = [...this.$store.getters.timesheet]
      let newObj = {start: start}
      timesheet.push(newObj)

      dbPromise().then((db) => {
        let tx = db.transaction('timesheet-archive', 'readwrite')
        let timesheetStore = tx.objectStore('timesheet-archive')
        timesheetStore.put(timesheet, this.empID)
        return tx.complete
      }).then(() => {
        console.log('data saved locally')
      })
    },
    saveLocally (data) {
      dbPromise().then((db) => {
        let tx = db.transaction('outbox-timesheets', 'readwrite')
        let timesheetStore = tx.objectStore('outbox-timesheets')
        timesheetStore.put(data)
        return tx.complete
      }).then(() => {
        console.log('data saved locally')
      })
    },
    formatTimeStringToDate () {
      return moment(this.time, 'HH:mm').toDate()
    },
    formatTimeDateToString () {
      return moment(this.time).format('hh:mm a')
    },
    disclaimerAction () {
      this.$router.push('/')
    },
    remove (item) {
      this.load.splice(this.load.indexOf(item), 1)
      this.load = [...this.load]
    },
    triggerUpdateChip () {
      const sel = this.$refs.loadSelect
      console.log(sel)
      let val = this.$refs.loadSelect.getCurrentTag()
      val = val.trim()
      this.load.push(val)
      sel.updateTags()
    },
    getCharCode (e) {
      const charCode = e.target.value.charAt(e.target.value.length - 1).charCodeAt()
      if (charCode === 32 && this.$refs.loadSelect.getCurrentTag().trim() !== '') {
        this.triggerUpdateChip()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RecoveryModeFormComponent.vue